var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.344,5.71c0-0.73,0.074-1.122,1.199-1.122h1.502V1.871h-2.404c-2.886,0-3.903,1.36-3.903,3.646v1.765h-1.8V10h1.8v8.128h3.601V10h2.403l0.32-2.718h-2.724L11.344,5.71z"}));
}

FacebookInline.defaultProps = {"className":"svg-icon","viewBox":"0 0 20 20"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
